import React, { Component } from 'react'
import { translate } from 'react-i18next';
import _ from 'lodash';

declare let window: any;

interface IProps {
  /**
   * `shortname` tells the Disqus service your forum's shortname,
   * which is the unique identifier for your website as registered
   * on Disqus. If undefined , the Disqus embed will not load.
   */
  shortname: string,

  /**
   * `identifier` tells the Disqus service how to identify the
   * current page. When the Disqus embed is loaded, the identifier
   * is used to look up the correct thread. If disqus_identifier
   * is undefined, the page's URL will be used. The URL can be
   * unreliable, such as when renaming an article slug or changing
   * domains, so we recommend using your own unique way of
   * identifying a thread.
   */
  identifier?: string,

  /**
   * `title` tells the Disqus service the title of the current page.
   * This is used when creating the thread on Disqus for the first time.
   * If undefined, Disqus will use the <title> attribute of the page.
   * If that attribute could not be used, Disqus will use the URL of the page.
   */
  title?: string,

  /**
   * `url` tells the Disqus service the URL of the current page.
   * If undefined, Disqus will take the global.location.href.
   * This URL is used to look up or create a thread if disqus_identifier
   * is undefined. In addition, this URL is always saved when a thread is
   * being created so that Disqus knows what page a thread belongs to.
   */
  url?: string,

  /**
   * `category_id` tells the Disqus service the category to be used for
   * the current page. This is used when creating the thread on Disqus
   * for the first time.
   */
  category_id?: string,

  /**
   * `onNewComment` function accepts one parameter `comment` which is a
   * JavaScript object with comment `id` and `text`. This allows you to track
   * user comments and replies and run a script after a comment is posted.
   */
  onNewComment?: Function,

  t?: Function,
  i18n?: any,
  tReady?: any,
}

class Disqus extends Component<IProps> {
  componentDidMount () {
    if (typeof window !== 'undefined' && window.document) {
      const component = this;
      window.disqus_config = function () {
        this.page.identifier = component.props.identifier;
        this.page.title = component.props.title;
        this.page.url = component.props.url;
        this.page.category_id = component.props.category_id;
        this.callbacks.onNewComment = component.props.onNewComment;
        this.language = component.props.i18n.language;
      };
      const disqusScript = document.querySelector(`script[src$="disqus.com/embed.js"]`);
      let found = !!disqusScript;
      if (!found) {
        const script = document.createElement('script');
        script.src = `//${this.props.shortname}.disqus.com/embed.js`;
        script.async = true;
        document.body.appendChild(script);
      } else {
        setTimeout(() => {
          window.DISQUS.reset({
            reload: true,
            config: window.disqus_config,
          });
        }, 1000);
      }
    }
  }

  render () {
    let props = _.cloneDeep(this.props);
    for (let i in [
      'shortname',
      'identifier',
      'title',
      'url',
      'category_id',
      'onNewComment',
    ]) {
      delete props[i];
    }
    return (<div id="disqus_thread" {..._.filter(props, item => !_.includes(item, ['tReady', 't']))}/>);
  }
}

export default translate()(Disqus);
